"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "next-themes";
import { SyncProvider } from "@/components/sync/sync-context";
import { ImportProvider } from "@/components/import/import-context";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <SyncProvider>
          <ImportProvider>
            {children}
          </ImportProvider>
        </SyncProvider>
      </ThemeProvider>
    </SessionProvider>
  );
}
